export default __webpack_public_path__ + "static/media/blog02.1966dcb5.jpg";